import React from 'react';

import './style.scss';

interface ModalProps {
    rightButtonText: string;
    title: string;
    content: string;
    icon: string;
    target: string;
}

const Modal = ({ rightButtonText, title, content, icon, target }: ModalProps) => {
    return (
        <div
            aria-hidden="true"
            aria-labelledby="modalLabel"
            className="modal fade modal-alert"
            id={target || 'alert-modal'}
            role="dialog"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="alert-modal-content modal-content">
                    <div className="modal-inner">
                        <i className="material-icons-outlined align-middle">{icon}</i>
                        <div className="inner-content">
                            <span className="text-content">{title}</span>
                            <span className="text-name">{content}</span>
                        </div>
                    </div>
                    <div className="modal-bottom">
                        <button className="btn btn-primary right-button" data-dismiss="modal" type="button">
                            {rightButtonText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Modal;
